import { SiteItemStatus, ClusterPod } from './site';

export type SiteDeviceItem = {
  deviceName: string;
  status: SiteDeviceStatus;
  deviceLabel: string;
};

export enum SiteDeviceStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
}

export enum SiteDeviceItemField {
  DeviceName = 'deviceName',
  Status = 'status',
  Label = 'deviceLable',
}

export type SiteDeviceNodesItem = {
  name: string;
  serverUrl?: string;
  serverToken?: string;
  status: SiteDeviceNodeStatus;
  pods?: string;
  hostName?: string;
  cpuCores?: number;
  memoryKi?: string;
  diskEphemeral?: string;
  gpuCount?: number;
  gpuMemoryGiB?: number;
  cudaDriverVersion?: string;
  cudaRuntimeVersion?: string;
  operatingSystem?: string;
  kubernetesVersion?: string;
  instanceType?: string;
  ipAddress?: string;
  cpuCoresFormatted?: string;
  memoryFormatted?: string;
  diskSizeFormatted?: string;
  gpuCountFormatted?: string;
  gpuMemoryFormatted?: string;
  cpuUtilized?: string;
  memoryUtilized?: string;
  diskUtilized?: string;
  gpuMemoryUtilized?: string;
  gpuCoreUtilized?: string;
  gpuProduct?: string;
};

export enum SiteDeviceNodeStatus {
  Ready = 'Ready',
  Healthy = 'Healthy',
  InProgress = 'InProgress',
  Unknown = 'Unknown',
  Unavailable = 'UNAVAILABLE',
}

export enum SiteDeviceNodesItemField {
  Name = 'name',
  Status = 'status',
  Pods = 'pods',
  ServerUrl = 'serverUrl',
  ServerToken = 'serverToken',
  HostName = 'hostName',
  CpuCores = 'cpuCores',
  MemoryKi = 'memoryKi',
  DiskEphemeral = 'diskEphemeral',
  GpuCount = 'gpuCount',
  GpuMemoryGiB = 'gpuMemoryGiB',
  CudaDriverVersion = 'cudaDriverVersion',
  CudaRuntimeVersion = 'cudaRuntimeVersion',
  OperatingSystem = 'operatingSystem',
  KubernetesVersion = 'kubernetesVersion',
  InstanceType = 'instanceType',
  IpAddress = 'ipAddress',
  CpuCoresFormatted = 'cpuCoresFormatted',
  MemoryFormatted = 'memoryFormatted',
  DiskSizeFormatted = 'diskSizeFormatted',
  GpuCountFormatted = 'gpuCountFormatted',
  GpuMemoryFormatted = 'gpuMemoryFormatted',
  CpuUtilized = 'cpuUtilized',
  MemoryUtilized = 'memoryUtilized',
  DiskUtilized = 'diskUtilized',
  GpuMemoryUtilized = 'gpuMemoryUtilized',
  GpuCoreUtilized = 'gpuCoreUtilized',
  GpuProduct = 'gpuProduct',
}

export type SiteDeviceProjectItem = {
  nameSpace: string;
  pods?: ClusterPod[];
};

export enum SiteDeviceProjectItemField {
  Namespace = 'nameSpace',
}

export type ClusterDetail = {
  name: string;
  state: SiteItemStatus;
};

export enum SiteClusterItemField {
  Name = 'name',
  ProviderType = 'providerType',
  InstanceId = 'instanceId',
  AuthType = 'authType',
}

export enum SiteClusterProviderType {
  Rancher = 'Rancher',
  Spectro = 'Spectro',
}
